<ng-container *ngTemplateOutlet="language === 'en' ? en : fr " />

<!--TEMPLATES ENGLISH-->
<ng-template #en>
  <div class="td-wb-preferences__agreement-form">
    <h1 class="td-wb-preferences__agreement-form__header">NASDAQ Subscriber Agreement</h1>
    @if (disabled()) {
      <td-wb-notification class="td-wb-preferences-agreements__completed"
                          notificationType="success">
        Copy for "Viewing Purposes only" :
        No action required, this agreement has been accepted. Thank You.
      </td-wb-notification>
    }
    <p class="td-wb-preferences__agreement-form--title">NASDAQ Subscriber Agreement</p>
    <p class="td-wb-preferences__agreement-form--copy">THE VENDOR AND ITS AGENTS MAY NOT MODIFY OR WAIVE ANY TERM OF THIS AGREEMENT. ANY ATTEMPT TO MODIFY THIS
    AGREEMENT, EXCEPT BY NASDAQ, IS VOID.</p>
    <ol class="td-wb-preferences__agreement-form--primary td-wb-preferences__agreement-form--copy">
      <li class="td-wb-preferences__agreement-form--primary-item">The word "NASDAQ" means The NASDAQ Stock Market, Inc. and its affiliates. The word "Information"
        means certain data and other information: relating to securities or other financial instruments, products,
        vehicles or devices; or relating to Persons regulated by NASDAQ or to activities of NASDAQ; or gathered by
        NASDAQ from other sources. The word "or" includes the word "and". The phrase "Claims
        or Losses" means any and all liabilities, obligations, losses, damages, penalties, claims, actions,
        suits, costs, judgments, settlements, and expenses of whatever nature, whether incurred by or issued against
        an indemnified party or a third party, including, without limitation,
        <ol class="td-wb-preferences__agreement-form--secondary">
          <li class="td-wb-preferences__agreement-form--secondary-item">indirect, special, punitive, consequential or incidental loss or damage, (including, but not limited
            to, trading losses, loss of anticipated profits, loss by reason of shutdown in operation or
            increased expenses of operation, or other indirect loss or damage) and
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item">administrative costs, investigatory costs, litigation costs, and auditors' and attorneys' and fees
            and disbursements (including in-house personnel). The word "Person" means any natural
            person, proprietorship, corporation, partnership, or other entity whatsoever. The phrase "Non-Professional
            Subscriber" means any natural person who is neither:
            <ol class="td-wb-preferences__agreement-form--tertiary">
              <li class="td-wb-preferences__agreement-form--tertiary-item">registered or qualified in any capacity with the SEC, the Commodities Futures Trading
                Commission, any state securities agency, any securities exchange or association, or any
                commodities or futures contract market or association;
              </li>
              <li class="td-wb-preferences__agreement-form--tertiary-item">engaged as an "investment advisor" as that term is defined in Section 201 (11) of
                the Investment Advisors Act of 1940 (whether or not registered or qualified under that Act);
                nor,
              </li>
              <li class="td-wb-preferences__agreement-form--tertiary-item">employed by a bank or other organization exempt from registration under federal or state
                securities laws to perform functions that would require registration or qualification if
                such functions were performed for an organization not so exempt. The phrase "Professional
                Subscriber" means all other persons who do not meet the definition of Non-Professional
                Subscriber. When it appears alone, the word "Subscriber" encompasses all
                Non-Professional and Professional Subscribers. The phrase "Vendor's Service" means
                the service from a vendor, including the data processing equipment, software, and
                communications facilities related thereto, for receiving, processing, transmitting, using
                and disseminating the Information to or by Subscriber.
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">Subscriber is granted the right to receive from NASDAQ the Information under the terms stated herein or in
        the NASD Rules. "NASD Rules" shall mean all applicable laws (including intellectual property,
        communications, and securities laws), statutes, and regulations, the rules and regulations of the SEC, the
        rules and regulations of NASDAQ including, but not limited to, those requirements established by NASDAQ's
        rule filings (with such SEC approval as may be required), NASDAQ's decisions and interpretations and any
        User Guides, or successors of the components of the NASD Rules, as they may exist at the time. For
        Professional Subscriber, if any payment is due directly to NASDAQ under this Agreement, payment in full is
        due NASDAQ in immediately available U.S. funds, within 30 days of the date of an invoice, whether or not use
        is made of, or access is made to, the Information. Interest shall be due from the date of the invoice to the
        time that the amount(s) that are due have been paid. Subscriber shall assume full and complete
        responsibility for the payment of any taxes, charges or assessments imposed on Subscriber or NASDAQ (except
        for U.S. federal, state, or local income taxes, if any, imposed on NASDAQ) by any foreign or domestic
        national, state, provincial or local governmental bodies, or subdivisions thereof, and any penalties or
        interest, relating to the provision of the Information to Subscriber.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">The Information is licensed only for the personal use of the Non-Professional Subscriber and the internal
        business use and/or personal use of the Professional Subscriber. By representing to Vendor that Subscriber
        is a non-professional, or by continuing to receive the Information at a non-professional subscriber rate,
        Subscriber is affirming to Vendor and NASDAQ that Subscriber meets the definition of Non-Professional
        Subscriber as set forth in paragraph 1 above. Subscriber will promptly give written notice to Vendor of any
        change in the name or place of residence or place of business at which the Information is received.
        Subscriber may not sell, lease, furnish or otherwise permit or provide access to the Information to any
        other Person or to any other office, or place. Subscriber will not engage in the operation of any illegal
        business; use or permit anyone else to use the Information, or any part thereof, for any illegal purpose; or
        violate any NASD Rule. Professional Subscribers may, on a non-continuous basis, furnish limited amounts of
        the Information to customers: in written advertisements, correspondence, or other literature; or during
        voice telephonic conversations not entailing computerized voice, automated information inquiry systems, or
        similar technologies. Subscriber may not present the Information rendered in any unfair, misleading, or
        discriminatory format. Subscriber shall take reasonable security precautions to prevent unauthorized Persons
        from gaining access to the Information.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">Subscriber acknowledges that NASDAQ, in its sole discretion, may from time to time make modifications to its
        system or the Information. Such modifications may require corresponding changes to be made in Vendor's
        Service. Changes or the failure to make timely changes by Vendor or Subscriber may sever or affect
        Subscriber's access to or use of the Information. NASDAQ shall not be responsible for such effects.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">NASDAQ grants to Subscriber a nonexclusive, non-transferable license during the term of the Agreement to
        receive and use the Information transmitted to it by Vendor and thereafter to use such Information for any
        purpose not inconsistent with the terms of the Agreement or with the NASD Rules. Subscriber acknowledges and
        agrees that NASDAQ has proprietary rights in the Information that originates on or derives from markets
        regulated or operated by NASDAQ and compilation or other rights in Information gathered from other sources.
        Subscriber further acknowledges and agrees that NASDAQ's third party Information providers have exclusive
        proprietary rights in their respective Information. In the event of any misappropriation or misuse, NASDAQ
        or its third party information providers shall have the right to obtain injunctive relief for its respective
        materials. Subscriber will attribute source as appropriate under all the circumstances.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">Subscriber acknowledges that NASDAQ, as a subsidiary of NASD, when required to do so by NASD in fulfillment
        of NASD's statutory obligations, may by notice to Vendor unilaterally limit or terminate the right of any or
        all Persons to receive or use the Information, and that Vendor will immediately comply with any such notice
        and will terminate or limit the furnishing of the Information and confirm such compliance by notice to
        NASDAQ. Any affected Person will have available to it such procedural protections as are provided by the
        Exchange Act and applicable rules thereunder. Neither NASDAQ nor NASD shall have any liability when
        complying with such NASD notice.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">Professional Subscriber shall make its premises available to NASDAQ for physical inspection of Vendor's
        Service and of Professional Subscriber's use of the Information (including review of any records regarding
        use of, or access to, the Information and the number and locations of all devices that receive Information),
        all at reasonable times, upon reasonable notice, to ensure compliance with this Agreement. Non-professional
        Subscriber shall comply promptly with any reasonable request from NASDAQ for information regarding the
        Non-Professional Subscriber’s receipt, processing, display and redistribution of the Information.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">To the extent permitted by applicable law, Subscriber acknowledges and agrees that the termination of the
        Vendor's Service for failure to make payments shall not be deemed or considered to be, and Subscriber waives
        any right to represent or assert that any such exercise constitutes, an act or omission or an improper
        denial or limitation of access by NASDAQ to any service or facility operated by NASDAQ as contemplated in
        Section 11A of the Exchange Act, or any other provision of the Exchange Act, or any rule, regulation, or
        interpretation adopted thereunder.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">NASDAQ'S WARRANTIES/DISCLAIMER OF WARRANTIES. NASDAQ SHALL ENDEAVOR TO OFFER THE INFORMATION AS PROMPTLY AND
        ACCURATELY AS IS REASONABLY PRACTICABLE. IN THE EVENT THAT THE INFORMATION IS NOT AVAILABLE AS A RESULT OF A
        FAILURE BY NASDAQ TO PERFORM ITS OBLIGATIONS UNDER THIS AGREEMENT, NASDAQ WILL ENDEAVOR, GIVING DUE REGARD
        FOR THE COST, TIME, AND EFFECT ON OTHER USERS, TO CORRECT ANY SUCH FAILURE. IN THE EVENT THAT THE
        INFORMATION IS NOT AVAILABLE, IS DELAYED, IS INTERRUPTED, IS INCOMPLETE, OR IS NOT ACCURATE OR IS OTHERWISE
        MATERIALLY AFFECTED FOR A CONTINUOUS PERIOD OF FOUR (4) HOURS OR MORE DURING THE TIME THAT NASDAQ REGULARLY
        TRANSMITS THE INFORMATION DUE TO THE FAULT OF NASDAQ (EXCEPT FOR A REASON PERMITTED IN THIS AGREEMENT OR IN
        NASDAQ'S AGREEMENT WITH THE VENDOR), SUBSCRIBER'S OR ANY OTHER PERSON'S EXCLUSIVE REMEDY AGAINST NASDAQ
        SHALL BE
        <ol class="td-wb-preferences__agreement-form--secondary">
          <li class="td-wb-preferences__agreement-form--secondary-item">IF SUBSCRIBER OR ANY OTHER PERSON CONTINUES TO RECEIVE THE INFORMATION OR ANY OTHER DATA AND/OR
            INFORMATION OFFERED BY NASDAQ, A PRORATED MONTH'S CREDIT OF ANY MONIES DUE, IF ANY, FOR THE AFFECTED
            INFORMATION DIRECTLY TO NASDAQ FROM SUBSCRIBER, OR, IF APPLICABLE, FROM SAID OTHER PERSON, FOR THE
            PERIOD AT ISSUE OR,
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item">IF SUBSCRIBER OR ANY OTHER PERSON NO LONGER RECEIVES EITHER THE INFORMATION OR ANY OTHER DATA AND/OR
            INFORMATION OFFERED BY NASDAQ, A PRORATED MONTH'S REFUND OF ANY MONIES DUE FOR THE AFFECTED
            INFORMATION DIRECTLY TO NASDAQ FROM SUBSCRIBER, OR, IF APPLICABLE, FROM SAID OTHER PERSON, FOR THE
            PERIOD AT ISSUE. SUCH CREDIT OR REFUND SHALL, IF APPLICABLE, BE REQUESTED BY WRITTEN NOTICE TO
            NASDAQ WITH ALL PERTINENT DETAILS. BEYOND THE WARRANTIES STATED IN THIS SECTION, THERE ARE NO OTHER
            WARRANTIES OF ANY KIND, EXPRESS, IMPLIED OR STATUTORY (INCLUDING, WITHOUT LIMITATION, TIMELINESS,
            TRUTHFULNESS, SEQUENCE, COMPLETENESS, ACCURACY, FREEDOM FROM INTERRUPTION), ANY IMPLIED WARRANTIES
            ARISING FROM TRADE USAGE, COURSE OF DEALING, OR COURSE OF PERFORMANCE, OR THE IMPLIED WARRANTIES OF
            MERCHANTABILITY OR FITNESS FOR A PARTICULAR USE OR PURPOSE.
          </li>
        </ol>
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">NASDAQ’S LIMITATION OF LIABILITY.
        <ol class="td-wb-preferences__agreement-form--secondary">
          <li class="td-wb-preferences__agreement-form--secondary-item">EXCEPT AS MAY OTHERWISE BE SET FORTH HEREIN, NASDAQ SHALL NOT BE LIABLE TO SUBSCRIBER, ITS VENDOR OR
            ANY OTHER PERSON FOR INDIRECT, SPECIAL, PUNITIVE, CONSEQUENTIAL, OR INCIDENTAL LOSS OR DAMAGE
            (INCLUDING, BUT NOT LIMITED TO, TRADING LOSSES, LOSS OF ANTICIPATED PROFITS, LOSS BY REASON OF
            SHUTDOWN IN OPERATION OR INCREASED EXPENSES OF OPERATION, COST OF COVER, OR OTHER INDIRECT LOSS OR
            DAMAGE) OF ANY NATURE ARISING FROM ANY CAUSE WHATSOEVER, EVEN IF NASDAQ HAS BEEN ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGES.
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item">NASDAQ SHALL NOT BE LIABLE TO SUBSCRIBER OR ANY OTHER PERSON FOR ANY UNAVAILABILITY, INTERRUPTION,
            DELAY, INCOMPLETENESS, OR INACCURACY OF THE INFORMATION THAT LASTS LESS THAN FOUR (4) CONTINUOUS
            HOURS DURING THE TIME THAT NASDAQ REGULARLY TRANSMITS THE INFORMATION OR IF THE INFORMATION IS
            MATERIALLY AFFECTED FOR LESS THAN FOUR (4) CONTINUOUS HOURS DURING THE TIME THAT NASDAQ REGULARLY
            TRANSMITS THE INFORMATION.
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item">IF NASDAQ IS FOR ANY REASON HELD LIABLE TO SUBSCRIBER OR TO ANY OTHER PERSON, WHETHER IN TORT OR IN
            CONTRACT, THE LIABILITY OF NASDAQ WITHIN A SINGLE YEAR (FROM THE EFFECTIVE DATE OF THE AGREEMENT) OF
            THE AGREEMENT [COMBINED WITH THE TOTAL OF ALL CLAIMS OR LOSSES OF SUBSCRIBER'S VENDOR, AND ANY OTHER
            PERSON CLAIMING THROUGH, ON BEHALF OF, OR AS HARMED BY SUBSCRIBER] IS LIMITED TO AN AMOUNT OF
            SUBSCRIBER’S DAMAGES THAT ARE ACTUALLY INCURRED BY SUBSCRIBER IN REASONABLE RELIANCE, AND
            WHICH AMOUNT DOES NOT EXCEED THE LESSER OF:
            <ol class="td-wb-preferences__agreement-form--tertiary">
              <li class="td-wb-preferences__agreement-form--tertiery-item">IF SUBSCRIBER OR ANY OTHER PERSON CONTINUES TO RECEIVE THE INFORMATION OR ANY OTHER DATA
                AND/OR INFORMATION OFFERED BY NASDAQ, A PRORATED MONTH'S CREDIT OF ANY MONIES DUE DIRECTLY
                TO NASDAQ FROM SUBSCRIBER, OR, IF APPLICABLE, FROM ANY OTHER PERSON, FOR THE INFORMATION AT
                ISSUE DURING THE PERIOD AT ISSUE OR, IF SUBSCRIBER OR ANY OTHER PERSON NO LONGER RECEIVES
                EITHER THE INFORMATION OR ANY OTHER DATA AND/OR INFORMATION OFFERED BY NASDAQ, A REFUND OF
                ANY MONIES DUE DIRECTLY TO NASDAQ FROM SUBSCRIBER, OR, IF APPLICABLE, FROM ANY OTHER PERSON,
                FOR THE INFORMATION AT ISSUE DURING THE PERIOD AT ISSUE; OR
              </li>
              <li class="td-wb-preferences__agreement-form--tertiery-item">$500.00.</li>
            </ol>
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item">THIS SECTION SHALL NOT RELIEVE NASDAQ, SUBSCRIBER OR ANY OTHER PERSON FROM LIABILITY FOR DAMAGES
            THAT RESULT FROM THEIR OWN GROSS NEGLIGENCE OR WILLFUL TORTIOUS MISCONDUCT, OR FROM PERSONAL INJURY
            OR WRONGFUL DEATH CLAIMS.
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item">SUBSCRIBER AND NASDAQ UNDERSTAND AND AGREE THAT THE TERMS OF THIS SECTION REFLECT A REASONABLE
            ALLOCATION OF RISK AND LIMITATION OF LIABILITY.
          </li>
        </ol>
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">THIRD PARTY INFORMATION PROVIDERS' DISCLAIMERS OF WARRANTIES/LIMITATIONS OF LIABILITIES. NASDAQ'S THIRD
        PARTY INFORMATION PROVIDERS MAKE NO WARRANTIES OF ANY KIND, EXPRESS, IMPLIED OR STATUTORY (INCLUDING,
        WITHOUT LIMITATION, TIMELINESS, TRUTHFULNESS, SEQUENCE, COMPLETENESS, ACCURACY, FREEDOM FROM INTERRUPTION),
        ANY IMPLIED WARRANTIES ARISING FROM TRADE USAGE, COURSE OF DEALING, OR COURSE OF PERFORMANCE, OR THE IMPLIED
        WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR USE OR PURPOSE AND THEY SHALL HAVE NO LIABILITY
        FOR THE ACCURACY OF, OR FOR DELAYS OR OMISSIONS IN, ANY OF THE INFORMATION PROVIDED BY THEM. NASDAQ'S THIRD
        PARTY INFORMATION PROVIDERS SHALL ALSO HAVE NO LIABILITY FOR ANY DAMAGES, WHETHER DIRECT OR INDIRECT,
        WHETHER LOST PROFITS, INDIRECT, SPECIAL OR CONSEQUENTIAL DAMAGES OF THE SUBSCRIBER OR ANY OTHER PERSON
        SEEKING RELIEF THROUGH SUBSCRIBER, EVEN IF THE THIRD PARTY INFORMATION PROVIDERS HAVE BEEN ADVISED OF THE
        POSSIBILITY OF SUCH DAMAGES. IN NO EVENT WILL THE LIABILITY OF THE THIRD PARTY INFORMATION PROVIDERS OR
        THEIR AFFILIATES TO SUBSCRIBER OR ANY OTHER PERSON SEEKING RELIEF THROUGH SUBSCRIBER PURSUANT TO ANY CAUSE
        OF ACTION, WHETHER IN CONTRACT, TORT, OR OTHERWISE, EXCEED THE FEE PAID BY SUBSCRIBER OR ANY OTHER PERSON
        SEEKING RELIEF THROUGH SUBSCRIBER, AS APPLICABLE.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">Notwithstanding any other term or condition of this Agreement, NASDAQ, its third party information providers
        or Subscriber shall not be obligated to perform or observe their respective obligations undertaken in this
        Agreement (except for obligations to make payments hereunder and regulatory obligations) if prevented or
        hindered from doing so by any circumstances found to be beyond their control.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">Subscriber will indemnify and hold harmless NASDAQ and its employees, officers, directors, and other agents
        from any and all Claims or Losses imposed on, incurred by or asserted as a result of or relating to:
        <ol class="td-wb-preferences__agreement-form--secondary">
          <li class="td-wb-preferences__agreement-form--secondary-item">any noncompliance by Subscriber with the terms and conditions hereof;</li>
          <li class="td-wb-preferences__agreement-form--secondary-item">any third-party actions related to Subscriber's receipt and use of the Information, whether
            authorized or unauthorized under the Agreement.
          </li>
        </ol>
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">Each party warrants and represents and will indemnify and hold harmless (and in every case, NASDAQ shall be
        permitted to solely defend and settle) another party (including NASDAQ) and their officers, directors,
        employees, and other agents, against any Claims or Losses arising from, involving, or relating to a claim of
        infringement or other violation of an intellectual property right by the indemnifying party, its actions or
        omissions, equipment, or other property. This right is conditioned on the indemnified party giving prompt
        written notice to the indemnifying party (as does not prejudice the defense) of the Claims or Losses and
        providing cooperation in the defense of the Claims or Losses (without waiver of attorney-client,
        work-product or other legal privilege, or disclosure of information legally required to be kept
        confidential).
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">Subscriber agrees that NASDAQ may enforce the terms of this Agreement against any Person, whether or not
        Vendor or Subscriber is a party to any such action or against Subscriber itself. In any action there shall
        be available injunctive relief or damages, with the prevailing party being awarded costs and attorneys' fees
        (including in-house counsel).
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">In the event of any conflict between the terms of this Agreement and of the Vendor's agreement, the terms of
        this Agreement shall prevail as between NASDAQ and Subscriber.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">In addition to terminations permitted under the Vendor's agreement, this Agreement may be terminated by
        Subscriber on 30 days written notice to Vendor and by NASDAQ on 30 days written notice either to Vendor or
        Subscriber. NASDAQ may also alter any term of this Agreement on 60 days written notice either to Vendor or
        Subscriber, and any use after such date is deemed acceptance of the new terms. In the event of Subscriber
        breach, discovery of the untruth of any representation of Subscriber, or where directed by NASD in its
        regulatory authority, NASDAQ may terminate this Agreement on not less than three (3) days written notice to
        Subscriber provided either by NASDAQ or Vendor.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">NASDAQ does not endorse or approve any equipment, Vendor, or Vendor's Service.</li>
      <li class="td-wb-preferences__agreement-form--primary-item">Natural persons executing this Agreement warrant and represent that they are at least eighteen (18) years of
        age. Subscriber and the Person executing this Agreement on behalf of Subscriber which is a proprietorship,
        corporation, partnership or other entity, represent that such Person is duly authorized by all necessary and
        appropriate corporate or other action to execute the Agreement on behalf of Subscriber.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">All notices, invoices, and other communications required to be given in writing under this Agreement shall
        be directed to: The NASDAQ Stock Market, Inc., 1735 K Street, NW, Washington, DC 20006, Attn.: Manager:
        Market Data Distribution, or to Subscriber at the last address known to the Vendor, and shall be deemed to
        have been duly given upon actual receipt by the parties, or upon constructive receipt if sent by certified
        mail, postage pre-paid, return receipt requested, at such address or to such other address as any party
        hereto shall hereafter specify by written notice to the other party or parties hereto.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">Except as otherwise provided herein, no provision of this Agreement may be amended, modified, or waived,
        unless by an instrument in writing executed by a duly authorized signatory of the party against whom
        enforcement of such amendment, modification, or waiver is sought. No failure on the part of NASDAQ or
        Subscriber to exercise, no delay in exercising, and no course of dealing with respect to any right, power,
        or privilege under this Agreement shall operate as a waiver thereof, nor shall any single or partial
        exercise of any such right, power, or privilege preclude any other or further exercise thereof or the
        exercise of any other right, power, or privilege under this Agreement. If any of the provisions of this
        Agreement, or application thereof to any Person or circumstance, shall to any extent be held invalid or
        unenforceable, the remainder of this Agreement, or the application of such terms or provisions to Persons or
        circumstances other than those as to which they are held invalid or unenforceable, shall not be affected
        thereby and each such term and provision of this Agreement shall be valid and enforceable to the fullest
        extent permitted by law.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">The terms of this Agreement apply to those obligations that survive any cancellation, termination, or
        rescission, namely, obligations relating to intellectual property, indemnification, limitation of liability,
        warranties, disclaimer of warranties, and Exchange Act related provisions.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">This Agreement shall be deemed to have been made in the United States in the State of Maryland and shall be
        construed and enforced in accordance with, and the validity and performance hereof shall be governed by, the
        laws of the State of Maryland, without reference to principles of conflicts of laws thereof. Subscriber
        hereby consents to submit to the jurisdiction of the courts of or for the State of Maryland in connection
        with any action or proceeding instituted relating to this Agreement.
      </li>
    </ol>
    <div>
      <p class="td-wb-preferences__agreement-form--title">On-Line NASDAQ Subscriber Agreement</p>
      <ul class="td-wb-preferences__agreement-form--copy td-wb-ul--basic">
        <li>
          <span class="td-wb-preferences__agreement-form--copy-bold">DISCLOSURE - PLEASE READ</span>
          Subscribers must sign a contract entitled The NASDAQ Stock Market, Inc. (“NASDAQ�)
          Subscriber Agreement ("Agreement") in order to receive Information [see definition in
          Paragraph [1] of the Agreement] from NASDAQ. While all terms are important, please particularly note the
          following. For more information regarding each term, the paragraph number at the end of each term refers
          to the paragraph in the Agreement where more information can be located.
        </li>
        <li>
          <span class="td-wb-preferences__agreement-form--copy-bold">RESTRICTIONS ON USES & TRANSFER:</span> Subscribers may not provide access to Information
          or transfer the Agreement to others. The Information is only for personal non-professional use or, if
          you are a Professional Subscriber (see definition in Paragraph [1] of the Agreement) for internal
          business use and/or personal use. [Paragraph 3]
        </li>
        <li>
          <span class="td-wb-preferences__agreement-form--copy-bold">MOST TYPES OF DAMAGES ARE EXCLUDED AND REMAINING DAMAGES ARE LIMITED:</span>
          NASDAQ is not liable for trading losses, lost profits or incidental, consequential or other indirect
          damages, even if the Information is untimely or incorrect. Other damages (if any), are strictly limited
          (in contract, tort, or otherwise) to a capped amount. [Paragraphs 9 and 10]
        </li>
        <li>
          <span class="td-wb-preferences__agreement-form--copy-bold">NO IMPLIED OR STATUTORY WARRANTIES OR DUTIES:</span>
          All warranties and duties (if any) are eliminated. There are no express warranties except for a Limited
          Warranty regarding efforts only. STOCK QUOTES MIGHT NOT BE CURRENT OR ACCURATE. [Paragraph 9]
        </li>
        <li>
          <span class="td-wb-preferences__agreement-form--copy-bold">SUBSCRIBERS PROVIDE AN INDEMNITY:</span>
          Subscriber indemnifies and holds harmless NASDAQ for any Claims or Losses (see definition in Paragraph
          [1] of the Agreement) resulting from Subscriber's breach of the Agreement, for Subscriber's infringement
          of a third party’s intellectual property rights, or from any third party suit related to
          Subscriber's use or receipt of the Information. [Paragraph 13 and 14]
        </li>
        <li>
          <span class="td-wb-preferences__agreement-form--copy-bold">MARYLAND LAWS AND COURTS APPLY:</span>
          Everything relating to the Agreement is governed by the laws of the United States and the State of
          Maryland and any disputes can only be heard in Maryland. [Paragraph 23]
        </li>
        <li>
          <span class="td-wb-preferences__agreement-form--copy-bold">NO ORAL AMENDMENTS & ONLY NASDAQ MAY AMEND:</span>
          The Agreement may not be altered orally and may be altered by NASDAQ pursuant to an Agreement procedure
          which includes notice either to Subscriber or to Vendor. Failure to terminate the Agreement before, or
          use of Information after, an amendment will be Subscriber’s consent (or confirmation of an earlier
          consent) to the amendment. [Paragraph 17 and 21]
        </li>
        <li>
          <span class="td-wb-preferences__agreement-form--copy-bold">VENDORS CAN IMPACT SUBSCRIBER’S RIGHTS BUT NOT NASDAQ’S RIGHTS:</span>
          Vendor does not have authority to change the Agreement. Vendors are obligated to provide notice of
          NASDAQ changes to Subscriber, but if they do not, NASDAQ's notice to Vendor is still effective, as to
          Subscriber including notice of cancellation. [Above Paragraph 1 and Paragraph 17]
        </li>
      </ul>
    </div>
    <a class="td-wb-preferences__agreement-form--expanded-link" role="button" tabindex="0" (click)="collapsed = !collapsed" [attr.aria-expanded]="collapsed">
      <td-wb-icon iconId="circle-{{collapsed ? 'minus' : 'plus'}}" />
      <span class="td-wb-expand-section-link td-wb-icon--margin-left">
        Please expand to read Nasdaq Clarification Statement
      </span>
    </a>
    @if (collapsed) {
      <div class="td-wb-preferences__agreement-form--expanded-content">
        <p class="td-wb-preferences__agreement-form--title">Nasdaq Subscriber Agreement Clarification Statement</p>
        <p class="td-wb-preferences__agreement-form--copy">
          The Nasdaq Stock Market, Inc. requires each subscriber accessing real-time Nasdaq market information to
          execute the standard Nasdaq Consolidated Subscriber Agreement. The Nasdaq Agreement that TD customers are
          required to execute is a standard form that all online brokerage customers must execute in order to receive
          real-time Nasdaq data through their broker.
        </p>
        <p class="td-wb-preferences__agreement-form--copy">
          TD Waterhouse Canada Inc. has recently received a number of inquiries from its customers expressing concerns
          regarding Section 7 of the Agreement. To assist with understanding the language contained in the Agreement,
          Nasdaq has provided the following statements to help interpret this section.
        </p>
        <ol class="td-wb-preferences__agreement-form--copy td-wb-ul--basic">
          <li>
            For a non-professional subscriber (as defined in Section 1 of the Agreement), Nasdaq's record keeping
            requirement is that, upon Nasdaq's request, the subscriber make a good faith attempt to provide Nasdaq
            with information regarding the time period during which he or she had online access to real-time Nasdaq
            market data through TD Waterhouse Canada Inc. (i.e., approximate start and stop dates for the service).
            Nasdaq would not expect the subscriber to provide any information on the type or amount of data that he
            accessed, the devices through which he accessed that data, or the specific dates on which he accessed
            data.
          </li>
          <li>
            With respect to the Subscriber making its physical premises available to Nasdaq for inspection, Nasdaq
            has never exercised this right under the contract with a non-professional subscriber. In the unlikely
            event that Nasdaq did request access to a subscriber's premises, the subscriber may deny the request.
            Nasdaq would limit its response to that event to termination of the subscriber's Subscriber Agreement
            and access to real-time Nasdaq market data through TD Waterhouse Canada Inc.
          </li>
        </ol>
        <p class="td-wb-preferences__agreement-form--copy">
          The Nasdaq Stock Market, Inc
        </p>
      </div>
    }
    @if (!disabled()) {
      <p class="td-wb-preferences__agreement-form--copy"
        >
        The Agreement appears below. If you are at least 18 years old, sign it as either a Professional or a
        Non-Professional Subscriber by signing your name or other symbol of your signature on the "Signature"
      line in the appropriate signature part(s) below.</p>
    }

    @if (!disabled()) {
      <div class="td-wb-preferences__agreement-form--copy"
        >
        <span class="td-wb-preferences__agreement-form--copy-bold">
          SIGNATURE SECTION: This section incorporates all terms of The Nasdaq Subscriber Agreement by this
          reference.
        </span>
      </div>
    }

    @if (!disabled()) {
      <div>
        <ng-container *ngTemplateOutlet="form" />
      </div>
    }

    @if (disabled()) {
      <p class="td-wb-preferences__agreement-form--copy td-wb-preferences__agreement-form--copy-bold">
        <span>Dated: </span>
        <span [innerText]="selectedAgreementEffectiveDate | tdWbDate: { format: 'DATE_TIME' }"></span>
      </p>
    }
  </div>

</ng-template>

<!--TEMPLATES FRENCH-->
<ng-template #fr>
  <div>
    <h1 class="td-wb-preferences__agreement-form__header">Entente du souscripteur NASDAQ</h1>
    @if (disabled()) {
      <td-wb-notification class="td-wb-preferences-agreements__completed"
                          notificationType="success">
        Copie pour « À des fins de visualisation seulement » :
        Aucune mesure à prendre, ce contrat a été accepté. Merci.
      </td-wb-notification>
    }
    <p class="td-wb-preferences__agreement-form--title">Contrat d'abonnement de NASDAQ</p>

    <p class="td-wb-preferences__agreement-form--copy">LE FOURNISSEUR ET SES MANDATAIRES NE PEUVENT MODIFIER AUCUNE CLAUSE DU PRÉSENT CONTRAT, NI Y RENONCER.
    TOUTE TENTATIVE DE MODIFIER LE PRÉSENT CONTRAT, SAUF PAR NASDAQ, EST NULLE.</p>

    <ol class="td-wb-preferences__agreement-form--primary td-wb-preferences__agreement-form--copy">
      <li class="td-wb-preferences__agreement-form--primary-item"> Le terme « NASDAQ » désigne The NASDAQ Stock Market, Inc. et les sociétés de son groupe. Le terme « informations » désigne certaines données et d'autres renseignements se rapportant à des titres ou à d'autres instruments, produits, véhicules ou dispositifs financiers, concernant des personnes régies par NASDAQ ou des activités de NASDAQ, ou recueillis par NASDAQ auprès d'autres sources. Le terme « ou » englobe le terme « et ». L'expression «réclamations ou pertes » désigne les responsabilités, obligations, pertes, dommages, pénalités, réclamations, actions, poursuites, coûts, jugements, règlements et charges, de quelque nature que ce soit, qu'ils soient engagés ou subis par une partie indemnisée ou un tiers, ou encore intentés ou déposés contre l'une ou l'autre de ces parties, y compris
        <ol class="td-wb-preferences__agreement-form--secondary">
          <li class="td-wb-preferences__agreement-form--secondary-item"> les pertes ou dommages indirects, spéciaux, punitifs, consécutifs ou accessoires (dont les
            pertes découlant d'opérations sur valeurs mobilières, la perte de bénéfices prévus, la perte résultant d'un arrêt de
          l'exploitation ou d'une hausse des frais d'exploitation ou d'autres pertes ou dommages indirects) et</li>
          <li class="td-wb-preferences__agreement-form--secondary-item">les frais administratifs, les frais d'enquête, les frais de litige et les honoraires et débours des vérificateurs et des
            avocats (notamment le personnel interne). Le mot « personne » désigne toute personne physique, entreprise
            individuelle, société par actions, société de personnes ou autre entité quelle qu'elle soit. L'expression « abonné
            non professionnel » désigne toute personne physique qui n'est :
            <ol class="td-wb-preferences__agreement-form--tertiary">
              <li class="td-wb-preferences__agreement-form--tertiary-item">(a) ni inscrite ou agréée à quelque titre que ce soit auprès de la SEC, de la Commodities Futures Trading Commission, tout organisme d'État en matière de valeurs mobilières, toute bourse ou association en matière de valeurs mobilières ou tout marché ou toute association de marchandises ou de contrats à terme;</li>
              <li class="td-wb-preferences__agreement-form--tertiary-item">(b) ni engagée à titre de « investment advisor » (conseiller en placements) au
                sens de l'article 201(11) de l'Investment Advisors Act of 1940 (la « Loi de 1940 ») (qu'elle soit ou non inscrite ou
              agréée en vertu de la Loi de 1940); </li>
              <li class="td-wb-preferences__agreement-form--tertiary-item">(c) ni employée par une banque ou une autre organisation qui est dispensée de
                s'inscrire en vertu de la législation fédérale ou d'un État en matière de valeurs mobilières afin de remplir des
                fonctions dont l'exécution, pour le compte d'une organisation non dispensée, nécessiterait une inscription ou une
                autorisation. L'expression « abonné professionnel » désigne toute personne qui ne correspond pas à la définition
                d'abonné non professionnel. Lorsqu'il figure seul, le terme « abonné » englobe les abonnés professionnels et non
                professionnels. L'expression « service du fournisseur » désigne le service assuré par un fournisseur, y compris le
                matériel informatique, les logiciels et les installations de communications qui s'y rapportent pour recevoir,
              traiter, transmettre, utiliser et diffuser les informations à l'abonné ou provenant de l'abonné.</li>
            </ol>
          </li>
        </ol>
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item"> NASDAQ accorde à l'abonné le droit de recevoir les informations selon les conditions énoncées dans la présente ou
        dans les règles NASD. L'expression « règles NASD » désigne toutes les lois et les règlements applicables (y compris
        les lois en matière de propriété intellectuelle, de communications et de valeurs mobilières), les règles et les
        règlements de la SEC, les règles et les règlements de NASDAQ y compris les exigences prévues aux règles déposées par
        NASDAQ (avec l'approbation de la SEC le cas échéant), les décisions et interprétations de NASDAQ et les guides
        d'utilisateur, le cas échéant, ou les textes qui remplacent les règles NASD à un moment donné. Lorsqu'un paiement
        doit être versé directement à NASDAQ par un abonné professionnel aux termes du présent contrat, il lui est versé en
        entier, en fonds américains immédiatement disponibles, dans les 30 jours qui suivent la date d'une facture, que
        l'abonné ait utilisé ou non les informations ou qu'il y ait eu accès ou non. Des intérêts courent depuis la date de
        la facture jusqu'au moment où la ou les sommes dues sont versées. L'abonné assume l'entière responsabilité du
        paiement des taxes, frais ou droits exigés de l'abonné ou de NASDAQ (à l'exception des impôts sur le revenu pouvant
        être exigés de NASDAQ, le cas échéant, par le gouvernement fédéral, un État ou une administration locale aux
        États-Unis) par tout organisme gouvernemental étranger ou américain de compétence nationale, d'État, provinciale ou
        locale, ou par toute subdivision d'un tel organisme, ainsi que des pénalités et intérêts, s'il y en a, qui découlent
        de la fourniture des informations à l'abonné.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item"> Le droit d'utilisation des informations est réservé à un usage personnel de la part de l'abonné non professionnel
        et à un usage commercial interne ou un usage personnel de la part de l'abonné professionnel. En déclarant au
        fournisseur qu'il n'est pas un professionnel ou en continuant de recevoir les informations au tarif de l'abonné non
        professionnel, l'abonné affirme au fournisseur et à NASDAQ qu'il répond à la définition d'abonné non professionnel
        décrite au paragraphe 1 ci-dessus. L'abonné doit aviser par écrit et sans tarder le fournisseur de tout changement
        dans le nom ou le lieu de résidence ou le lieu d'affaires où les informations sont reçues. L'abonné ne peut pas
        vendre, louer ou transmettre les informations, ni y donner autrement accès, à toute autre personne ou à tout autre
        bureau ou lieu. L'abonné ne doit pas s'engager dans une entreprise illicite, utiliser les informations, ou une
        partie des informations, à une fin illicite, ni permettre à quiconque de le faire, ni enfreindre les règles NASD.
        Les abonnés professionnels peuvent, sur une base ponctuelle, fournir certaines informations aux clients dans des
        publicités écrites, de la correspondance ou d'autres documents, ou au cours de conversations téléphoniques qui ne
        font pas appel à des systèmes vocaux informatisés, à des systèmes d'interrogation informatisés ou à d'autres
        technologies semblables. L'abonné ne peut pas présenter les informations reçues de manière injuste, trompeuse ou
        discriminatoire. L'abonné doit prendre des mesures de sécurité raisonnables pour empêcher des personnes non
        autorisées d'avoir accès aux informations.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item"> L'abonné reconnaît que NASDAQ, à son gré, peut apporter de temps à autre des modifications à son système ou aux
        informations. De telles modifications peuvent obliger le fournisseur à faire des changements correspondants dans son
        service. Des changements ou le défaut d'apporter des changements en temps opportun par le fournisseur ou l'abonné
        peuvent empêcher l'abonné d'avoir accès aux informations ou de les utiliser, ou nuire à leur accès ou à leur
        utilisation. NASDAQ ne sera pas responsable de telles conséquences.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item"> NASDAQ confère à l'abonné, pendant la durée du contrat, le droit non exclusif et non transférable de recevoir et
        d'utiliser les informations transmises par le fournisseur et par la suite d'employer les informations à toute fin
        qui respecte les conditions du contrat ou les règles NASD. L'abonné reconnaît et accepte que NASDAQ a des droits de
        propriété sur les informations provenant des marchés réglementés ou exploités par NASDAQ et d'autres droits (dont
        ceux de compilation) sur les informations recueillies d'autres sources. L'abonné reconnaît en outre que les tiers
        fournisseurs d'informations de NASDAQ ont un droit de propriété exclusif sur leurs informations respectives. En cas
        de détournement ou de mauvais usage, NASDAQ et ses tiers fournisseurs d'informations ont le droit d'exercer des
        recours en injonction pour leurs documents respectifs. L'abonné précisera la source de façon appropriée dans toutes
        les situations.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item"> L'abonné reconnaît que NASDAQ, à titre de filiale de la NASD et lorsque la NASD l'oblige à le faire pour remplir
        les obligations statutaires de la NASD, peut demander au fournisseur de restreindre ou de révoquer unilatéralement
        le droit de toute personne de recevoir ou d'utiliser les informations et que le fournisseur doit se conformer
        immédiatement à une telle demande et cesser ou restreindre la fourniture des informations et aviser NASDAQ qu'il s'y
        est conformé. Toute personne touchée pourra se prévaloir des dispositions de protection prévues dans la Exchange Act
        et les règles y afférentes. NASDAQ et la NASD n'assument aucune responsabilité pour s'être conformés à une telle
        demande de la NASD.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item"> L'abonné professionnel doit permettre l'accès à ses locaux à NASDAQ en vue d'une inspection physique du service
        du fournisseur et de l'utilisation des informations par l'abonné professionnel (y compris l'examen de tout dossier
        concernant l'utilisation des informations, l'accès aux informations ainsi que le nombre et l'emplacement de tous les
        dispositifs qui reçoivent des informations), à tout moment raisonnable, moyennant un préavis raisonnable, afin de
        vérifier la conformité aux dispositions du présent contrat. L'abonné non professionnel se conforme promptement à
        toute demande de renseignements raisonnable de la part de NASDAQ concernant la réception, le traitement, l'affichage
        et la redistribution des informations par l'abonné non professionnel.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item"> Dans la mesure permise par le droit applicable, l'abonné reconnaît que la cessation du service du fournisseur
        pour cause de non-paiement ne peut pas être considérée comme un acte, une omission ou une interdiction ou
        restriction irrégulière de l'accès par NASDAQ à tout service ou établissement exploité par NASDAQ comme il est prévu
        à l'article 11A ou à toute autre disposition de la Exchange Act, ou dans tout autre règle, règlement ou
        interprétation adopté en vertu de cette loi, et l'abonné renonce à tout droit d'affirmer qu'une telle cessation du
        service du fournisseur constitue un acte ou une omission ou une interdiction ou restriction irrégulière d'accès.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item"> GARANTIES ET DÉNIS DE GARANTIE DE NASDAQ. NASDAQ S'EMPLOIE À OFFRIR LES INFORMATIONS DE LA MANIÈRE LA PLUS RAPIDE
        ET EXACTE QU'IL EST RAISONNABLEMENT POSSIBLE. DANS LE CAS OÙ LES INFORMATIONS NE SONT PAS DISPONIBLES PAR SUITE DU
        DÉFAUT DE NASDAQ DE REMPLIR SES OBLIGATIONS AUX TERMES DU PRÉSENT CONTRAT, NASDAQ S'EFFORCERA, EN TENANT COMPTE DU
        COÛT, DU DÉLAI ET DE L'EFFET SUR LES AUTRES UTILISATEURS, DE PRENDRE DES MESURES POUR CORRIGER UN TEL DÉFAUT. DANS
        LE CAS OÙ LES INFORMATIONS SONT INACCESSIBLES, RETARDÉES, INTERROMPUES, INCOMPLÈTES, INEXACTES OU TOUCHÉES AUTREMENT
        DE MANIÈRE IMPORTANTE DURANT UNE PÉRIODE CONTINUE DE QUATRE (4) HEURES OU PLUS PENDANT LE TEMPS OÙ NASDAQ TRANSMET
        RÉGULIÈREMENT LES INFORMATIONS À CAUSE D'UN MANQUEMENT DE NASDAQ (SAUF POUR UNE RAISON PERMISE DANS LE PRÉSENT
        CONTRAT OU DANS LE CONTRAT CONCLU PAR NASDAQ AVEC LE FOURNISSEUR), LE SEUL RECOURS DE L'ABONNÉ OU DE TOUTE AUTRE
        PERSONNE À L'ENDROIT DE NASDAQ EST (A) SI L'ABONNÉ OU TOUTE AUTRE PERSONNE CONTINUE DE RECEVOIR LES INFORMATIONS OU
        D'AUTRES DONNÉES ET/OU INFORMATIONS OFFERTES PAR NASDAQ, UN CRÉDIT AU PRORATA DES SOMMES DUES POUR CE MOIS, LE CAS
        ÉCHÉANT, DIRECTEMENT À NASDAQ PAR L'ABONNÉ OU, S'IL Y A LIEU, PAR CETTE AUTRE PERSONNE, POUR LES INFORMATIONS
        TOUCHÉES ET LA PÉRIODE EN CAUSE, OU (B) SI L'ABONNÉ OU TOUTE AUTRE PERSONNE NE REÇOIT PLUS LES INFORMATIONS OU
        D'AUTRES DONNÉES ET/OU INFORMATIONS OFFERTES PAR NASDAQ, UN REMBOURSEMENT AU PRORATA DES SOMMES DUES POUR CE MOIS
        DIRECTEMENT À NASDAQ PAR L'ABONNÉ OU, S'IL Y A LIEU, PAR CETTE AUTRE PERSONNE, POUR LES INFORMATIONS TOUCHÉES ET LA
        PÉRIODE EN CAUSE. LA DEMANDE DE CE CRÉDIT OU DE CE REMBOURSEMENT, SELON LE CAS, EST ACHEMINÉE PAR ÉCRIT À NASDAQ
        AVEC TOUS LES DÉTAILS PERTINENTS. SAUF LES GARANTIES ÉNONCÉES DANS LA PRÉSENTE CLAUSE, AUCUNE GARANTIE DE QUELQUE
        NATURE QUE CE SOIT N'EST DONNÉE, DE MANIÈRE EXPLICITE, IMPLICITE OU LÉGALE (Y COMPRIS POUR L'ACTUALITÉ, LA VÉRACITÉ,
        LA SÉQUENCE, L'EXHAUSTIVITÉ, L'EXACTITUDE ET L'ABSENCE D'INTERRUPTION), NI AUCUNE GARANTIE IMPLICITE DÉCOULANT D'UNE
        PRATIQUE COMMERCIALE, D'UNE CONDUITE HABITUELLE OU DE MODALITÉS D'EXÉCUTION, NI AUCUNE GARANTIE IMPLICITE DE QUALITÉ
        MARCHANDE OU DE CONFORMITÉ À UN USAGE OU UN BESOIN PARTICULIER.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item"> LIMITATIONS DE LA RESPONSABILITÉ DE NASDAQ.
        <ol class="td-wb-preferences__agreement-form--secondary">
          <li class="td-wb-preferences__agreement-form--secondary-item"> SAUF DISPOSITION CONTRAIRE ÉNONCÉE DANS LE PRÉSENT CONTRAT,
            NASDAQ N'EST PAS RESPONSABLE ENVERS L'ABONNÉ, SON FOURNISSEUR OU TOUTE AUTRE PERSONNE POUR DES PERTES OU DES
            DOMMAGES INDIRECTS, SPÉCIAUX, PUNITIFS, CONSÉCUTIFS OU ACCESSOIRES (Y COMPRIS LES PERTES DÉCOULANT D'OPÉRATIONS SUR
            VALEURS MOBILIÈRES, LA PERTE DE BÉNÉFICES PRÉVUS, LA PERTE RÉSULTANT D'UN ARRÊT DE L'EXPLOITATION OU D'UNE HAUSSE
            DES FRAIS D'EXPLOITATION, ET LE COÛT DE LA PROTECTION OU AUTRE PERTE OU DOMMAGE INDIRECT) DE QUELQUE NATURE QUE CE
            SOIT ET QUELLE QU'EN SOIT LA CAUSE, MÊME SI NASDAQ A ÉTÉ PRÉVENUE DE LA POSSIBILITÉ DE TELS DOMMAGES.
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item">NASDAQ Q N'EST PAS RESPONSABLE ENVERS L'ABONNÉ OU TOUTE AUTRE PERSONNE LORSQUE LES INFORMATIONS SONT
            INDISPONIBLES, INTERROMPUES, RETARDÉES, INCOMPLÈTES OU INEXACTES DURANT UNE PÉRIODE CONTINUE DE MOINS DE QUATRE (4)
            HEURES PENDANT LE TEMPS OÙ NASDAQ TRANSMET DE FAÇON RÉGULIÈRE LES INFORMATIONS, OU ENCORE LORSQUE LES INFORMATIONS
            SONT TOUCHÉES DE FAÇON IMPORTANTE PENDANT UNE PÉRIODE CONTINUE DE MOINS DE QUATRE (4) HEURES PENDANT LE TEMPS OÙ
            NASDAQ TRANSMET RÉGULIÈREMENT LES INFORMATIONS.
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item">SI NASDAQ EST JUGÉE RESPONSABLE POUR UNE RAISON QUELCONQUE ENVERS L'ABONNÉ OU TOUTE AUTRE PERSONNE, QUE CETTE
            RESPONSABILITÉ SOIT CONTRACTUELLE OU DÉLICTUELLE, SA RESPONSABILITÉ POUR UNE SEULE ANNÉE DU CONTRAT (À PARTIR DE LA
            DATE D'ENTRÉE EN VIGUEUR DU CONTRAT), AJOUTÉE À L'ENSEMBLE DES RÉCLAMATIONS OU DES PERTES DU FOURNISSEUR DE
            L'ABONNÉ, ET DE TOUTE AUTRE PERSONNE PRÉSENTANT UNE RÉCLAMATION PAR L'ENTREMISE DE L'ABONNÉ, POUR SON COMPTE OU PAR
            SUITE D'UN PRÉJUDICE CAUSÉ PAR L'ABONNÉ, EST LIMITÉE AU MONTANT DES DOMMAGES EFFECTIVEMENT SUBIS PAR L'ABONNÉ,
            ÉTABLI AVEC UNE CONFIANCE RAISONNABLE ET N'EXCÉDANT PAS LE MOINDRE DES MONTANTS SUIVANTS :
            <ol class="td-wb-preferences__agreement-form--tertiary">
              <li class="td-wb-preferences__agreement-form--tertiary-item">LORSQUE L'ABONNÉ OU
                TOUTE AUTRE PERSONNE CONTINUE DE RECEVOIR LES INFORMATIONS OU D'AUTRES DONNÉES ET/OU INFORMATIONS OFFERTES PAR
                NASDAQ, UN CRÉDIT AU PRORATA DES SOMMES DUES POUR CE MOIS DIRECTEMENT À NASDAQ PAR L'ABONNÉ OU, LE CAS ÉCHÉANT, PAR
                TOUTE AUTRE PERSONNE, POUR LES INFORMATIONS EN QUESTION DURANT LA PÉRIODE EN CAUSE OU, LORSQUE L'ABONNÉ OU TOUTE
                AUTRE PERSONNE NE REÇOIT PLUS LES INFORMATIONS OU D'AUTRES DONNÉES ET/OU INFORMATIONS OFFERTES PAR NASDAQ, LE
                REMBOURSEMENT DES SOMMES DUES DIRECTEMENT À NASDAQ PAR L'ABONNÉ, OU, LE CAS ÉCHÉANT, PAR TOUTE AUTRE PERSONNE, POUR
                LES INFORMATIONS EN QUESTION DURANT LA PÉRIODE EN CAUSE; OU
              </li>
              <li class="td-wb-preferences__agreement-form--tertiary-item">500,00 $.</li>
            </ol>
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item">LE PRÉSENT ARTICLE NE DÉGAGE PAS NASDAQ, L'ABONNÉ OU TOUTE AUTRE PERSONNE DE LA RESPONSABILITÉ DES DOMMAGES QUI
            RÉSULTENT DE LEUR PROPRE NÉGLIGENCE GRAVE OU DE LEUR CONDUITE DÉLICTUEUSE DÉLIBÉRÉE, OU DE RÉCLAMATIONS POUR
            PRÉJUDICES CORPORELS OU DÉCÈS IMPUTABLE À UNE FAUTE.
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item">L'ABONNÉ ET NASDAQ COMPRENNENT ET ACCEPTENT QUE LES MODALITÉS DU PRÉSENT ARTICLE TRADUISENT UNE RÉPARTITION DU
            RISQUE ET UNE LIMITATION DE LA RESPONSABILITÉ RAISONNABLES.
          </li>
        </ol>
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item"> DÉNIS DE GARANTIE/LIMITATION DE LA RESPONSABILITÉ DES TIERS FOURNISSEURS D'INFORMATIONS. LES TIERS FOURNISSEURS
        D'INFORMATIONS DE NASDAQ NE DONNENT AUCUNE GARANTIE DE QUELQUE NATURE QUE CE SOIT, DE MANIÈRE EXPLICITE, IMPLICITE
        OU LÉGALE (Y COMPRIS POUR L'ACTUALITÉ, LA VÉRACITÉ, LA SÉQUENCE, L'EXHAUSTIVITÉ, L'EXACTITUDE, L'ABSENCE
        D'INTERRUPTION), NI AUCUNE GARANTIE IMPLICITE DÉCOULANT D'UNE PRATIQUE COMMERCIALE, D'UNE CONDUITE HABITUELLE OU DE
        MODALITÉS D'EXÉCUTION, NI AUCUNE GARANTIE IMPLICITE DE QUALITÉ MARCHANDE OU DE CONFORMITÉ À UN USAGE OU À UN BESOIN
        PARTICULIER. ILS N'ASSUMENT AUCUNE RESPONSABILITÉ POUR L'EXACTITUDE DES INFORMATIONS QU'ILS FOURNISSENT, NI POUR
        TOUT RETARD OU TOUTE OMISSION. EN OUTRE, LES TIERS FOURNISSEURS D'INFORMATIONS DE NASDAQ N'ONT AUCUNE RESPONSABILITÉ
        POUR LES DOMMAGES, DIRECTS OU INDIRECTS, LA PERTE DE BÉNÉFICES, LES DOMMAGES INDIRECTS, SPÉCIAUX OU ACCESSOIRES DE
        L'ABONNÉ OU DE TOUTE AUTRE PERSONNE QUI RECHERCHE UN REDRESSEMENT PAR L'ENTREMISE DE L'ABONNÉ, MÊME SI LES TIERS
        FOURNISSEURS D'INFORMATIONS ONT ÉTÉ AVISÉS DE LA POSSIBILITÉ DE TELS DOMMAGES. LA RESPONSABILITÉ DES TIERS
        FOURNISSEURS D'INFORMATIONS OU DES MEMBRES DE LEUR GROUPE ENVERS L'ABONNÉ OU TOUTE AUTRE PERSONNE QUI RECHERCHE UN
        REDRESSEMENT PAR L'ENTREMISE DE L'ABONNÉ AUX TERMES D'UNE CAUSE D'ACTION, CONTRACTUELLE, DÉLICTUELLE OU AUTREMENT,
        N'EXCÉDERA EN AUCUN CAS LES FRAIS PAYÉS PAR L'ABONNÉ OU TOUTE AUTRE PERSONNE RECHERCHANT RÉPARATION PAR L'ENTREMISE
        DE L'ABONNÉ, LE CAS ÉCHÉANT.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item"> Nonobstant toute autre condition ou modalité du présent contrat, NASDAQ, ses tiers fournisseurs d'informations
        et l'abonné ne seront pas tenus de remplir leurs obligations respectives découlant du présent contrat (à l'exception
        de l'obligation d'acquitter les paiements prévus dans le contrat et des obligations réglementaires) s'ils en sont
        empêchés par des circonstances indépendantes de leur volonté.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item"> L'abonné indemnisera NASDAQ et ses employés, dirigeants, administrateurs et autres mandataires et les tiendra à
        couvert de l'ensemble des réclamations formulées ou des pertes subies par suite ou à l'égard
        <ol class="td-wb-preferences__agreement-form--secondary">
          <li class="td-wb-preferences__agreement-form--secondary-item">du non-respect des
          conditions et modalités du présent contrat par l'abonné;</li>
          <li class="td-wb-preferences__agreement-form--secondary-item">de tout acte d'un tiers se rapportant à la réception et
            à l'utilisation des informations par l'abonné, qu'il soit autorisé ou non aux termes du contrat
          </li>
        </ol>
      </li>

      <li class="td-wb-preferences__agreement-form--primary-item"> Chaque partie s'engage à indemniser et tenir à couvert (et dans chaque cas, NASDAQ, agissant seule, est
        autorisée à présenter une défense et à accepter un règlement) une autre partie (y compris NASDAQ) et ses dirigeants,
        administrateurs, employés et autres mandataires de toutes les réclamations ou pertes découlant du non-respect d'un
        droit de propriété intellectuelle par la partie indemnisante, ses actions ou omissions, son matériel ou ses autres
        biens, ou s'y rapportant. Ce droit est conditionnel à ce que la partie indemnisée avise rapidement et par écrit la
        partie indemnisante (sans porter atteinte à la défense) des réclamations ou des pertes et à ce qu'elle collabore à
        la défense des réclamations ou des pertes (sans renonciation au secret professionnel de l'avocat, à la doctrine
        relative aux préparatifs d'une instance ou à un autre privilège juridique, et sans la divulgation de renseignements
        qui doivent légalement être tenus confidentiels).
      </li>

      <li class="td-wb-preferences__agreement-form--primary-item"> L'abonné accepte que NASDAQ puisse faire respecter les conditions du présent contrat à l'encontre de toute
        personne, peu importe si le fournisseur ou l'abonné est ou n'est pas une partie engagée dans une telle action, ou à
        l'encontre de l'abonné lui même. Toute action peut donner lieu à des mesures de redressement par voie d'injonction
        ou à des dommages-intérêts, les frais et dépens (y compris les honoraires du conseiller juridique interne) étant
        adjugés au gagnant.
      </li>

      <li class="td-wb-preferences__agreement-form--primary-item"> En cas de divergence entre le présent contrat et le contrat du fournisseur, le présent contrat a priorité dans
        les rapports entre NASDAQ et l'abonné.
      </li>

      <li class="td-wb-preferences__agreement-form--primary-item"> En plus des résiliations prévues dans le contrat du fournisseur, le présent contrat peut être résilié par
        l'abonné au moyen d'un préavis écrit de 30 jours au fournisseur et par NASDAQ moyennant un préavis écrit de 30 jours
        au fournisseur ou à l'abonné. En outre, NASDAQ peut modifier toute condition du présent contrat moyennant un préavis
        écrit de 60 jours donné au fournisseur ou à l'abonné, et toute utilisation faite après cette date est considérée
        comme une acceptation des nouvelles conditions. Advenant le non-respect du contrat par l'abonné, la découverte de
        toute déclaration erronée de l'abonné, ou sur directive donnée par la NASD en vertu de son pouvoir réglementaire,
        NASDAQ peut résilier le présent contrat au moyen d'un préavis écrit d'au moins trois (3) jours donné à l'abonné soit
        par NASDAQ ou par le fournisseur.
      </li>

      <li class="td-wb-preferences__agreement-form--primary-item"> NASDAQ n'appuie ni n'approuve aucun matériel, fournisseur ou service du fournisseur.</li>

      <li class="td-wb-preferences__agreement-form--primary-item"> Les personnes physiques qui signent le présent contrat garantissent et déclarent qu'elles sont âgées d'au moins
        dix-huit (18) ans. L'abonné et la personne qui signe le présent contrat pour le compte d'un abonné qui est une
        entreprise individuelle, une société par actions, une société de personnes ou une autre entité déclarent qu'elle est
        dûment autorisée par tous les actes jugés nécessaires et appropriés à signer le contrat au nom de l'abonné.
      </li>

      <li class="td-wb-preferences__agreement-form--primary-item"> Les avis, factures et autres communications devant être donnés par écrit en vertu du présent contrat sont
        adressés à : The NASDAQ Stock Market, Inc., 1735 K Street, NW, Washington, DC 20006, Attn.: Manager, Market Data
        Distribution, ou à l'abonné à la dernière adresse connue par le fournisseur, et sont considérés comme ayant été
        dûment donnés au moment de leur réception réelle par les parties ou de leur réception de droit en cas d'envoi par
        poste recommandée, avec avis de réception, port payé, à cette adresse ou à toute autre adresse que l'une des parties
        aux présentes communiquera par écrit à ou aux autres parties aux présentes.
      </li>

      <li class="td-wb-preferences__agreement-form--primary-item"> Sauf disposition contraire du présent contrat, aucune disposition du contrat ne peut faire l'objet d'une
        modification ou d'une renonciation autrement que par un écrit signé par un signataire dûment autorisé de la partie à
        l'encontre de laquelle la modification ou la renonciation est opposable. Aucun défaut de la part de NASDAQ ou de
        l'abonné d'exercer tout droit, pouvoir ou privilège en vertu du présent contrat, aucun retard à l'exercer ni aucune
        conduite habituelle à cet égard ne doit être vu comme une renonciation à ce droit, pouvoir ou privilège; en outre,
        aucun exercice unique ou partiel d'un tel droit, pouvoir ou privilège n'empêche le nouvel exercice ou l'exercice
        intégral d'un tel droit, pouvoir ou privilège ou l'exercice de tout autre droit, pouvoir ou privilège aux termes du
        présent contrat. Si l'une des dispositions du présent contrat - ou son application à l'égard d'une personne ou d'une
        situation - est jugée invalide ou inopposable, les autres conditions du contrat et l'application de cette
        disposition aux personnes ou situations autres que celles pour lesquelles elle a été jugée invalide ou inopposable,
        ne sont pas touchées, et chaque condition du présent contrat est valide et opposable dans toute la mesure permise
        par la loi.
      </li>

      <li class="td-wb-preferences__agreement-form--primary-item"> Les conditions du présent contrat s'appliquent aux obligations qui demeurent après toute annulation ou
        résiliation, c'est-à-dire les obligations se rapportant à la propriété intellectuelle, à l'indemnisation, à la
        limitation de la responsabilité, aux garanties, aux dénis de garantie et aux dispositions relatives à la Exchange
        Act.
      </li>

      <li class="td-wb-preferences__agreement-form--primary-item"> Le présent contrat est réputé avoir été conclu dans l'État du Maryland, aux États-Unis. Il est interprété et
        appliqué en conformité avec les lois de l'État du Maryland, sans égard aux principes de règlement des conflits de
        lois de l'État, et sa validité et son exécution sont régies par ces lois. L'abonné reconnaît par les présentes la
        compétence des tribunaux de l'État du Maryland relativement à toute action ou procédure intentée à l'égard du
        présent contrat.
      </li>
    </ol>
    <p class="td-wb-preferences__agreement-form--title">Contrat d'abonnement de NASDAQ en ligne</p>
    <ol class="td-wb-preferences__agreement-form--copy td-wb-ul--basic">
      <li><span class="td-wb-preferences__agreement-form--copy-bold">RENSEIGNEMENTS IMPORTANTS</span>
      Les abonnés doivent signer une convention intitulée Contrat d'abonnement de The NASDAQ
      Stock Market, Inc. (« NASDAQ
      ») (le « contrat ») afin de recevoir les informations [définies au paragraphe 1
      du contrat] de NASDAQ. Bien que
      toutes les clauses soient importantes, il convient tout particulièrement de noter les
      dispositions suivantes. Pour
      en savoir plus sur chaque clause, le lecteur est prié de consulter, dans le contrat, le
      paragraphe dont le numéro
      figure à la fin de chaque explication ci-dessous.
    </li>
    <li><span class="td-wb-preferences__agreement-form--copy-bold">RESTRICTIONS SUR LES UTILISATIONS ET LE TRANSFERT</span> : Il est interdit aux abonnés
    de donner accès aux informations ou
    de céder le contrat à des tiers. Les informations sont réservées à
    l'usage personnel de l'abonné non professionnel
    et à l'usage commercial interne ou à l'usage personnel de l'abonné professionnel (défini
    au paragraphe 1 du
    contrat). [Paragraphe 3]
  </li>
  <li><span class="td-wb-preferences__agreement-form--copy-bold">LA PLUPART DES TYPES DE DOMMAGES SONT EXCLUS, ET LES DOMMAGES RESTANTS SONT
  LIMITÉS</span> : NASDAQ n'est responsable
  d'aucune perte découlant d'opérations sur valeurs mobilières, d'aucune perte de bénéfices,
  de dommages consécutifs,
  accessoires ou d'autres dommages indirects, même lorsque les informations ne sont pas disponibles
  en temps opportun
  ou sont inexactes. Les autres dommages (s'il y a lieu) sont rigoureusement plafonnés, qu'il
  s'agisse de
  dommages-intérêts contractuels, délictuels ou autres. [Paragraphes 9 et 10]
</li>
<li><span class="td-wb-preferences__agreement-form--copy-bold">AUCUNE GARANTIE OU OBLIGATION IMPLICITE OU PRÉVUE PAR LA LOI</span> : Toute garantie ou
obligation, le cas échéant, est
supprimée. Il n'existe aucune garantie explicite, sauf une garantie limitée portant
exclusivement sur les efforts.
LES COURS BOURSIERS PEUVENT MANQUER D'ACTUALITÉ OU D'EXACTITUDE. [Paragraphe 9]
</li>
<li><span class="td-wb-preferences__agreement-form--copy-bold">LES ABONNÉS DOIVENT FOURNIR UNE INDEMNISATION</span> : L'abonné indemnise et dégage
de toute responsabilité NASDAQ
relativement à l'ensemble des réclamations ou pertes (définies au paragraphe 1 du
contrat) découlant du manquement,
de la part de l'abonné, au contrat, à l'atteinte aux droits de propriété
intellectuelle de tiers de la part de
l'abonné, ou à toute poursuite de tiers se rapportant à l'utilisation ou à
la réception des informations par
l'abonné. [Paragraphes 13 et 14]
</li>
<li><span class="td-wb-preferences__agreement-form--copy-bold">LE CONTRAT EST RÉGI PAR LES LOIS ET LES TRIBUNAUX DU MARYLAND</span> : Tous les aspects
du contrat sont régis par les lois
des États-Unis et de l'État du Maryland, et seul un tribunal du Maryland peut être
saisi d'un différend. [Paragraphe
23]
</li>
<li><span class="td-wb-preferences__agreement-form--copy-bold">LES MODIFICATIONS ORALES SONT INTERDITES ET SEULE NASDAQ PEUT APPORTER UNE MODIFICATION</span>
: Le contrat ne peut être
modifié oralement, mais il peut être modifié par NASDAQ conformément à
la procédure prévue au contrat, qui englobe
un avis à l'abonné ou au fournisseur. L'abonné consent (ou confirme un consentement
antérieur) à une modification
s'il omet de résilier le contrat avant la modification ou s'il utilise les informations après
celle-ci. [Paragraphes
17 et 21]
</li>
<li><span class="td-wb-preferences__agreement-form--copy-bold">LES FOURNISSEURS PEUVENT EXERCER UNE INFLUENCE SUR LES DROITS DE L'ABONNÉ, MAIS NON SUR
CEUX DE NASDAQ</span> : Le
fournisseur n'a pas l'autorité voulue pour modifier le contrat. En outre, il est tenu d'aviser
l'abonné des
modifications apportées par NASDAQ; par contre, s'il manque à cette obligation, l'avis
qu'il reçoit de NASDAQ - y
compris un avis de résiliation - reste en vigueur pour ce qui concerne l'abonné.
[Paragraphe 1 ci-dessus et
paragraphe 17]
</li>
</ol>
<a role="button" tabindex="0" (click)="collapsed = !collapsed" [attr.aria-expanded]="!collapsed">
  <td-wb-icon iconId="circle-{{collapsed ? 'minus' : 'plus'}}" />
  <span class="td-wb-icon--margin-left">
    S'il vous plaît élargir à lire la note explicative de NASDAQ
  </span>
</a>
@if (collapsed) {
  <div class=td-wb-preferences__agreement-form--expanded-content>
    <p class="td-wb-preferences__agreement-form--title">Énoncé de clarification du contrat d'abonnement à Nasdaq</p>
    <p class="td-wb-preferences__agreement-form--copy">The Nasdaq Stock Market, Inc. exige de chaque abonné qui accède en temps réel aux renseignements sur la
      bourse Nasdaq de se conformer au contrat d'abonnement consolidé standard de Nasdaq.Le contrat de Nasdaq
      auquel les clients de TD doivent se conformer consiste en un formulaire standard que tous les clients des
      services de courtage en ligne doivent exécuter afin d'obtenir des données de Nasdaq en temps réel par
      l'entremise de leur courtier.
    </p>
    <p class="td-wb-preferences__agreement-form--copy">
      Certains clients de TD Waterhouse Canada Inc. ont récemment exprimé leurs inquiétudes à l'égard de l'article
      7 du contrat. Or, afin de faciliter la compréhension du langage utilisé dans le contrat, Nasdaq a offert les
      énoncés ci-dessous pour l'interprétation de cette section.
    </p>
    <ol class="td-wb-preferences__agreement-form--copy td-wb-ul--basic">
      <li>
        Pour un abonné non professionnel (tel que décrit à la section 1 du contrat), l'exigence de Nasdaq en
        matière de tenue de dossier stipule que, à la demande de Nasdaq, l'abonné essaye de bonne foi de fournir
        à Nasdaq les renseignements relatifs à la période de temps pendant laquelle il ou elle avait accès aux
        données de la bourse Nasdaq en temps réel par l'entremise de TD Waterhouse Canada Inc. (p. ex. les dates
        de début et de fin approximatives du service). Nasdaq ne s'attend pas à ce que l'abonné fournisse des
        renseignements sur le type de données consultées, les appareils utilisés pour accéder à ces données ou
        les dates précises d'accès à ces données.
      </li>
      <li>
        À l'égard de l'accessibilité aux locaux de l'abonné par Nasdaq pour inspection, Nasdaq n'a jamais exercé
        ce droit en vertu de ce contrat avec un abonné non professionnel. Dans l'éventualité peu probable où
        Nasdaq exigeait un accès aux locaux d'un abonné, ce dernier peut refuser cette demande. Dans ce cas,
        Nasdaq limiterait son intervention à la résiliation du contrat d'abonnement de l'abonné et à
        l'interruption de l'accès en temps réel aux données sur la bourse Nasdaq par l'entremise de TD
        Waterhouse Canada Inc.
      </li>
    </ol>
    <p class="td-wb-preferences__agreement-form--copy">The Nasdaq Stock Market, Inc</p>
  </div>
}
@if (!disabled()) {
  <p class="td-wb-preferences__agreement-form--copy">
    Le contrat paraît ci-dessous. Si vous avez au moins 18 ans, veuillez le signer à titre d'abonné professionnel ou
    non professionnel en signant votre nom ou en apposant un autre symbole de votre signature à la ligne « Signature »
    dans la ou les parties réservées à cette fin ci-dessous. Retour au Résumé du contrat
  </p>
}
@if (!disabled()) {
  <div>
    <span class="td-wb-preferences__agreement-form--copy-bold">
      SECTION RÉSERVÉE À LA SIGNATURE - La présente section intègre par renvoi toutes les modalités du contrat d'abonnement de NASDAQ.
    </span>
  </div>
}

@if (!disabled()) {
  <div>
    <ng-container *ngTemplateOutlet="form" />
  </div>
}

@if (disabled()) {
  <p class="td-wb-preferences__agreement-form--copy td-wb-preferences__agreement-form--copy-bold">
    <span>daté : </span>
    <span [innerText]="selectedAgreementEffectiveDate | tdWbDate: { format: 'DATE_TIME' }"></span>
  </p>
}
</div>
</ng-template>

<!--FORM TEMPLATE-->
<ng-template #form>
  <td-wb-form novalidate autocomplete="off">
    <p class="td-wb-preferences__agreement-form--title">A. <span  class="td-wb-preferences__agreement-form--copy-bold"
    translate="tdWb.platform.preferences.agreements.NASDAQ.AGREEMENTS_SECTION_A"></span></p>
    <td-wb-form-row>
      <div class="td-wb-preferences__agreement-form--qualify-dropdown">
        <!-- YES/NO dropdown -->
        <td-wb-input-group class="td-wb-preferences__agreement-form--input-group-dropdown">
          <td-wb-input-group-label>
            <label class="td-wb-preferences__agreement-form--qualify-label" id="td-wb-aria-nasdaq-agreement-professional-label" for="professionalIndicator"
              translate="tdWb.platform.preferences.agreements.NASDAQ.SUBSCRIBER_NON_PROFESSIONAL">
            </label>
          </td-wb-input-group-label>
          <td-wb-input-group-field class="td-wb-preferences__agreement-form--input-group-field">
            <!--NOTE:this value is same as original code, so YES === false and NO===true-->
            <td-wb-dropdown class="td-wb-full-width"
              aria-labelledby="td-wb-aria-nasdaq-agreement-professional-label"
              [placeholder]="'tdWb.platform.preferences.agreements.NASDAQ.PLEASE_SELECT' | tdWbTranslate"
              name="professionalIndicator"
              id="professionalIndicator"
              [(ngModel)]="formModel.professionalIndicator"
              [disabled]="consolidateAgreement()"
              [attr.aria-disabled]="consolidateAgreement()"
              tdWbInput
              [required]="!consolidateAgreement()"
              [attr.aria-required]="!consolidateAgreement()">
              <td-wb-dropdown-item [value]="false">
                <span translate="tdWb.platform.preferences.agreements.YES"></span>
              </td-wb-dropdown-item>
              <td-wb-dropdown-item [value]="true">
                <span translate="tdWb.platform.preferences.agreements.NO"></span>
              </td-wb-dropdown-item>
            </td-wb-dropdown>
            <td-wb-input-errors errorKeyNamespace="tdWb.platform.preferences.agreements.FORM_ERR" />
          </td-wb-input-group-field>
        </td-wb-input-group>
      </div>
      <div class="td-wb-preferences__agreement-form--input-row">
        <!-- subscriber name -->
        <td-wb-input-group class="td-wb-preferences__agreement-form--input-group">
          <td-wb-input-group-label>
            <label for="clientName" translate="tdWb.platform.preferences.agreements.NASDAQ.SUBSCRIBER_NAME">
            </label>
          </td-wb-input-group-label>
          <td-wb-input-group-field class="td-wb-preferences__agreement-form--input-group-field">
            <input class="td-wb-full-width"
              type="text"
              id="clientName"
              name="clientName"
              [required]="!consolidateAgreement()"
              [attr.aria-required]="!consolidateAgreement()"
              maxlength="35"
              [disabled]="consolidateAgreement()"
              [attr.aria-disabled]="consolidateAgreement()"
              [(ngModel)]="formModel.clientName"
              tdWbInput>
              <td-wb-input-errors errorKeyNamespace="tdWb.platform.preferences.agreements.FORM_ERR" />
            </td-wb-input-group-field>
          </td-wb-input-group>
          <!-- Signature -->
          <td-wb-input-group class="td-wb-preferences__agreement-form--input-group">
            <td-wb-input-group-label>
              <label for="signature" translate="tdWb.platform.preferences.agreements.NASDAQ.SUBSCRIBER_SIGNATURE">
              </label>
            </td-wb-input-group-label>
            <td-wb-input-group-field class="td-wb-preferences__agreement-form--input-group-field">
              <input class="td-wb-full-width"
                type="text"
                id="signature"
                name="signature"
                [required]="!consolidateAgreement()"
                [attr.aria-required]="!consolidateAgreement()"
                maxlength="30"
                [disabled]="consolidateAgreement()"
                [attr.aria-disabled]="consolidateAgreement()"
                [(ngModel)]="formModel.signature"
                tdWbInput>
                <td-wb-input-errors errorKeyNamespace="tdWb.platform.preferences.agreements.FORM_ERR" />
              </td-wb-input-group-field>
            </td-wb-input-group>
          </div>
          <div class="td-wb-preferences__agreement-form--input-row">
            <!-- date -->
            <td-wb-input-group class="td-wb-preferences__agreement-form--input-group-date">
              <td-wb-input-group-label>
                <label for="subscriberAgreementDate" translate="tdWb.platform.preferences.agreements.NASDAQ.SUBSCRIBER_AGREEMENT_DATE">
                </label>
              </td-wb-input-group-label>
              <td-wb-input-group-field class="td-wb-preferences__agreement-form--input-group-field">
                <span id="subscriberAgreementDate"
                [innerText]="selectedAgreementEffectiveDate | tdWbDate:{format:'DATE_TIME'}"></span>
              </td-wb-input-group-field>
            </td-wb-input-group>
          </div>
          <p class="td-wb-preferences__agreement-form--title">B. <span  class="td-wb-preferences__agreement-form--copy-bold"
          translate="tdWb.platform.preferences.agreements.NASDAQ.AGREEMENTS_SECTION_B"></span></p>
          <div class="td-wb-preferences__agreement-form--input-row">
            <!--Title checkboxes-->
            <td-wb-input-group class="td-wb-preferences__agreement-form--checkbox-group" role="group" aria-labelledby="td-wb-aria-nasdaq-agreement-title-group-label">
              <td-wb-input-group-label>
                <span id="td-wb-aria-nasdaq-agreement-title-group-label"
                translate="tdWb.platform.preferences.agreements.NASDAQ.titles.TITLE"></span>
              </td-wb-input-group-label>
              <td-wb-input-group-field class="td-wb-preferences__agreement-form--checkbox-group-field">
                <div>
                  <!--ceo -->
                  <td-wb-checkbox class="td-wb-preferences__agreement-form--checkbox-group-checkbox"
                    name="CEO"
                    [(ngModel)]="formModel.titles.CEO"
                    [disabled]="consolidateAgreement()"
                    [attr.aria-disabled]="consolidateAgreement()">
                    <span translate="tdWb.platform.preferences.agreements.NASDAQ.titles.CEO">
                    </span>
                  </td-wb-checkbox>
                  <!--coo-->
                  <td-wb-checkbox class="td-wb-preferences__agreement-form--checkbox-group-checkbox"
                    name="COO"
                    [(ngModel)]="formModel.titles.COO"
                    [disabled]="consolidateAgreement()"
                    [attr.aria-disabled]="consolidateAgreement()">
                    <span translate="tdWb.platform.preferences.agreements.NASDAQ.titles.COO">
                    </span>
                  </td-wb-checkbox>
                  <!--Director-->
                  <td-wb-checkbox class="td-wb-preferences__agreement-form--checkbox-group-checkbox"
                    name="DIRECTOR"
                    [(ngModel)]="formModel.titles.DIRECTOR"
                    [disabled]="consolidateAgreement()"
                    [attr.aria-disabled]="consolidateAgreement()">
                    <span translate="tdWb.platform.preferences.agreements.NASDAQ.titles.DIRECTOR">
                    </span>
                  </td-wb-checkbox>
                  <!--president-->
                  <td-wb-checkbox class="td-wb-preferences__agreement-form--checkbox-group-checkbox"
                    name="PRESIDENT"
                    [(ngModel)]="formModel.titles.PRESIDENT"
                    [disabled]="consolidateAgreement()"
                    [attr.aria-disabled]="consolidateAgreement()">
                    <span translate="tdWb.platform.preferences.agreements.NASDAQ.titles.PRESIDENT">
                    </span>
                  </td-wb-checkbox>
                  <!--svp-->
                  <td-wb-checkbox class="td-wb-preferences__agreement-form--checkbox-group-checkbox"
                    name="SVP"
                    [(ngModel)]="formModel.titles.SVP"
                    [disabled]="consolidateAgreement()"
                    [attr.aria-disabled]="consolidateAgreement()">
                    <span translate="tdWb.platform.preferences.agreements.NASDAQ.titles.SVP">
                    </span>
                  </td-wb-checkbox>
                  <!-- vp -->
                  <td-wb-checkbox class="td-wb-preferences__agreement-form--checkbox-group-checkbox"
                    name="VP"
                    [(ngModel)]="formModel.titles.VP"
                    [disabled]="consolidateAgreement()"
                    [attr.aria-disabled]="consolidateAgreement()">
                    <span translate="tdWb.platform.preferences.agreements.NASDAQ.titles.VP">
                    </span>
                  </td-wb-checkbox>
                </div>
              </td-wb-input-group-field>
            </td-wb-input-group>
          </div>
          <div class="td-wb-preferences__agreement-form--input-row">
            <!-- Name -->
            <td-wb-input-group class="td-wb-preferences__agreement-form--input-group-print-name">
              <td-wb-input-group-label>
                <label for="agentName" translate="tdWb.platform.preferences.agreements.NASDAQ.SUBSCRIBER_AGENT_NAME">
                </label>
              </td-wb-input-group-label>
              <td-wb-input-group-field class="td-wb-preferences__agreement-form--input-group-field">
                <input class="td-wb-full-width"
                  type="text"
                  id="agentName"
                  name="agentName"
                  maxlength="30"
                  [disabled]="consolidateAgreement()"
                  [attr.aria-disabled]="consolidateAgreement()"
                  [(ngModel)]="formModel.agentName"
                  tdWbInput
                  [tdWbTitleNeedsNameValidator]="formModel.titles">
                  <td-wb-input-errors errorKeyNamespace="tdWb.platform.preferences.agreements.FORM_ERR" />
                </td-wb-input-group-field>
              </td-wb-input-group>
              <!--Other title-->
              <td-wb-input-group class="td-wb-preferences__agreement-form--input-group-print-name">
                <td-wb-input-group-label>
                  <label for="subscriberAgentTitle" translate="tdWb.platform.preferences.agreements.NASDAQ.titles.FREE_FORM">
                  </label>
                </td-wb-input-group-label>
                <td-wb-input-group-field class="td-wb-preferences__agreement-form--input-group-field">
                  <input class="td-wb-full-width"
                    type="text"
                    id="subscriberAgentTitle"
                    name="subscriberAgentTitle"
                    tdWbInput
                    maxlength="150"
                    [disabled]="consolidateAgreement()"
                    [attr.aria-disabled]="consolidateAgreement()"
                    [(ngModel)]="formModel.subscriberAgentTitle"
                    [tdWbTitleNeedsNameValidator]="formModel.titles">
                    <td-wb-input-errors errorKeyNamespace="tdWb.platform.preferences.agreements.FORM_ERR" />
                  </td-wb-input-group-field>
                </td-wb-input-group>
              </div>
            </td-wb-form-row>
          </td-wb-form>
        </ng-template>
